import { useState } from "react";

import { Popper, Paper, ClickAwayListener } from "@mui/material";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";

import { MenuItem, MenuList } from "components/common/Menu";
import "./UpdateMenu.scss";

function UpdateMenu({ isAch = false, onUpdateClick, onChangePaymentMethodClick, creditAllowed = false }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="update-menu-icon-wrapper">
      <MoreVertOutlinedIcon className="update-menu-icon" onClick={handleClick} />
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
        disablePortal={false}
        modifiers={[
          {
            name: "flip",
            enabled: true,
            options: {
              altBoundary: true,
              rootBoundary: "viewport",
              padding: 8,
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              boxShadow: "0px 8px 12px 0px var(--color-elevation-default, rgba(0, 0, 0, 0.16)) !important",
            }}
            className="update-menu-paper-style"
          >
            <MenuList autoWidth>
              <MenuItem
                key="update"
                value="Update"
                isDense
                className="menu-para-body-l-regular"
                onClick={() => {
                  if (onUpdateClick) {
                    onUpdateClick();
                  }
                  handleClose();
                }}
              />
              {isAch && creditAllowed && (
                <MenuItem
                  key="change"
                  value="Change to Credit/Debit Card"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangePaymentMethodClick) {
                      onChangePaymentMethodClick();
                    }
                    handleClose();
                  }}
                />
              )}
              {!isAch && (
                <MenuItem
                  key="change"
                  value="Change to ACH"
                  isDense
                  className="menu-para-body-l-regular"
                  onClick={() => {
                    if (onChangePaymentMethodClick) {
                      onChangePaymentMethodClick();
                    }
                    handleClose();
                  }}
                />
              )}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}

export default UpdateMenu;
